import { useContext } from 'react';
import { ASGContext, IASGContext } from '@mayfield/website/context';

export const useASG = (): IASGContext => useContext(ASGContext);
